import { FraudFlows } from './FraudFlows';

export default FraudFlows;
